import all from './each/all'
import pastepal from './each/pastepal'
import pushhero from './each/pushhero'

const factory = [
    pastepal,
    pushhero
].concat(all)

export default factory